var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCitrus = function SvgCitrus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "citrus_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h48v48H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#citrus_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#004152"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.713 4.57a.95.95 0 0 0-1.056.237 22.75 22.75 0 0 0 32.024 32.01.91.91 0 0 0 .025-1.34l-.022-.022-30.65-30.67a.95.95 0 0 0-.32-.215ZM10.27 2a3.45 3.45 0 0 1 2.547 1.031l30.626 30.646a3.41 3.41 0 0 1-.139 5.04l-.022.02A25.25 25.25 0 0 1 7.772 3.162a3.45 3.45 0 0 1 2.498-1.162Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.81 7.006c.5.476.52 1.267.044 1.767a14.75 14.75 0 0 0 20.834 20.872 1.25 1.25 0 0 1 1.72 1.814 17.25 17.25 0 0 1-24.365-24.41 1.25 1.25 0 0 1 1.767-.043Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.132 18.348a1.25 1.25 0 0 1 0 1.768l-11 11a1.25 1.25 0 0 1-1.768-1.768l11-11a1.25 1.25 0 0 1 1.768 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.298 19.232c0-.69.56-1.25 1.25-1.25h15.7c.69 0 1.25.56 1.25 1.25v15.7a1.25 1.25 0 0 1-2.5 0v-14.45h-14.45c-.69 0-1.25-.56-1.25-1.25Z"
  }))));
};
export default SvgCitrus;